
import React from 'react';
import { JUVCard } from '@/components/juv';
import { Leaf } from 'lucide-react';
import TooltipText from './TooltipText';

const ChemicalPeelsSection = () => {
  return (
    <JUVCard
      title="🍊 Chemical Peels"
      icon={Leaf}
      variant="glass"
      className="mb-8"
    >
      <div className="p-4 bg-juv-soft-blush/30 rounded-lg">
        <TooltipText
          text="Perfect Derma Peel – $599 (Promo: $399)"
          tooltip="Medical-grade peel for pigment, acne, and texture"
        />
      </div>
    </JUVCard>
  );
};

export default ChemicalPeelsSection;
